import styled from 'styled-components';
import { FormGroup, propStyling, tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
const CheckboxesContainer = styled.div.withConfig({
  displayName: "CheckboxGroup__CheckboxesContainer"
})(["align-content:start;display:grid;gap:", ";grid-auto-flow:column;grid-template-rows:repeat(4,auto);", ""], tombac.space(1, 2), propStyling);
export const CheckboxGroup = ({
  checkboxesContainerProps,
  children,
  ...props
}) => {
  return /*#__PURE__*/_jsx(FormGroup, {
    ...props,
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "CheckboxGroup",
    "data-sentry-source-file": "CheckboxGroup.tsx",
    children: /*#__PURE__*/_jsx(CheckboxesContainer, {
      $mt: "0.5sp",
      ...checkboxesContainerProps,
      "data-sentry-element": "CheckboxesContainer",
      "data-sentry-source-file": "CheckboxGroup.tsx",
      "data-sentry-element": "CheckboxesContainer",
      children: children
    })
  });
};